import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppLanguages, GACategoryName, GAEventNames, GAUniqueEventIds, GenderType } from "../../../helpers/Enums";
import { setSignupData } from '../../../redux/signup';
import { setSignupQuestions } from '../../../redux/signupQuestions';
import { RootState } from "../../../redux/store";
import { register } from "../../../services/accountService";
import { getRegistertionQuestions } from "../../../services/questionService";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const SelectGenderQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);

    const handleSelect = async (value: number) => {
        register.genderId = value;
        dispatch(setSignupData(register));

        //called to api to get other questions
        const { data } = await getRegistertionQuestions(AppLanguages.HEB, value);
        dispatch(setSignupQuestions(data))

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 2", "בחירת מין", GAUniqueEventIds.APP_SIGNUP)

        props.next();
    };

    return (
        <>
            <div className="content_sec wf-section">
                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">נתחיל להכיר: עם מי יש לנו הכבוד?</h2>
                </div>
                <div className="login_sec w-form">
                    <form>
                        <div className="form_field_content login">
                            <div className="field_block sex">
                                <a href="#" onClick={() => handleSelect(GenderType.FEMALE)} className="sex_button w-inline-block">
                                    <img src="assets/images/ic_women.svg" loading="lazy" alt="" className="sex_icon" />
                                    <div>אישה</div>
                                </a>
                                <a href="#" onClick={() => handleSelect(GenderType.MALE)} className="sex_button men w-inline-block">
                                    <img src="assets/images/ic_men.svg" loading="lazy" alt="" className="sex_icon" />
                                    <div>גבר</div>
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </>
    )
}

export default SelectGenderQuestion;